import { call, put, takeEvery } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { services } from 'globals/app';
import * as movieActions from 'ducks/movie';
import { CategoriesMoviesResponse } from 'types/api';

function* getCatetoriesRequested() {
  try {
    const response: AxiosResponse<CategoriesMoviesResponse> = yield call([services.movie, services.movie.getCategories]);
    yield put(movieActions.getCategoriesAsync.success(response.data.genres));
  } catch (err) {
    yield put(movieActions.getCategoriesAsync.failure(err));
  }
}

export function* movieSagas() {
  yield takeEvery(movieActions.GET_CATEGORIES_REQUESTED, getCatetoriesRequested)
}